<template>
  <section class="entities-page">
      <!-- Entity Table -->
      <Breadcrumbs
        :breadcrumbs="[
          { title: this.$t('menu.configurations'), disabled: true },
          { title: this.$t('menu.entities'), disabled: true }
        ]">
        <span slot="breadcrumbAfter" class="d-flex">
          <Searchable
          :querySearch.sync="querySearch"
          :searchTooltip="{placement: 'left', content: this.$t('search.term')}"/>
        </span>
      </Breadcrumbs>

      <div class="btn btn__floating btn__round__large" v-if="isFromEvollu">
        <va-button
          @click.prevent="createEntity">
          <i class="fa fa-plus"></i>
        </va-button>
      </div>

      <EntitiesTable
        ref="entitiesTable"
        :querySearch="querySearch"
      />

      <CreateOrUpdateEntity v-if="isCreatingEntity"
        @entity-created="onEntityCreated"
        @cancel="cancelCreateEntity"
      />

  </section>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'
import EntitiesTable from '@/components/entities/EntitiesTable'
import CreateOrUpdateEntity from '@/components/entities/CreateOrUpdateEntity'
import { TABLE_CONFIGS_ENTITIES } from '@/local-storage/LocalStorageKeys'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'

export default {
  mixins: [
    IsFromEvolluMixin,
    IndexTablesMixin
  ],
  components: {
    Breadcrumbs,
    Searchable,
    EntitiesTable,
    CreateOrUpdateEntity,
    IndexTablesMixin
  },
  data () {
    return {
      querySearch: '',
      isloading: false,
      expandUsers: true,
      showResetIcon: false,
      isCreatingEntity: false,
      localStorageKey: TABLE_CONFIGS_ENTITIES
    }
  },
  computed: {
    authService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server) || null
    }
  },
  created: function () {
    this.$store.dispatch('LOAD_BUSINESS_PLANS')
  },
  methods: {
    createEntity: function () {
      this.isCreatingEntity = true
    },
    cancelCreateEntity: function () {
      this.isCreatingEntity = false
    },
    refreshTable: function () {
      this.$refs.entitiesTable.refresh()
    },
    onEntityCreated: function (payload) {
      this.refreshTable()
      console.log(payload.entity.id)
      this.$router.push({ name: `${this.authService.slug}entities/id`, params: { id: payload.entity.id } })
    }
  }
}

</script>
